import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {Broadcast} from "../../../model/broadcast/broadcast";
import {ControlAction} from "../../../model/broadcast/control";
import {UtilService} from "../../../services/util.service";
import {LineupSpot} from "../../../model/broadcast/lineup-spot";
import {Player} from "../../../model/broadcast/player";
import {GamesService} from "../../../services/games.service";
import {Game} from "../../../model/broadcast/game";
import {NgForOf, NgIf} from "@angular/common";


@Component({
  selector: 'app-lineup',
  templateUrl: './lineup.component.html',
  styleUrls: ['./lineup.component.scss'],
  imports: [
    NgForOf,
    NgIf
  ],
  standalone: true
})
export class LineupComponent implements OnChanges, OnInit {

  @Input() broadcast: Broadcast;
  @Input() game: Game;
  @Input() homeCtrl: ControlAction;
  @Input() awayCtrl: ControlAction;

  lineup: LineupSpot[] = [];
  pitcher: Player = null;
  teamBrg: string;
  // Posledně zobrazená strana týmu. Drží se i při skrývání (else větev ho nemaže),
  // aby per-tým gradient (ODM skin) neproblikl při animaci na černou. Viz HTML třída.
  teamSide: 'home' | 'away' | '' = '';

  constructor(
    public utilService: UtilService,
    public gamesService: GamesService,
  ) { }

  ngOnInit(): void {
    this.prepareData();
  }

  ngOnChanges(): void {
    this.prepareData();
  }

  private prepareData(): void {
    //if (!this.game) return;
    if (this.homeCtrl === 'on') {
      if (this.broadcast.config.useManualLineups && this.broadcast.manualLineups?.homeLineup) {
        // Convert manual lineup to LineupSpot[] format
        this.lineup = this.broadcast.manualLineups.homeLineup.map(player => {
          return { players: [player] };
        });
        this.pitcher = this.broadcast.manualLineups.homePitcher || null;
      } else {
        this.lineup = this.game?.home?.lineup ?? [];
        // `pitchers` is absent until the game has one — before the first pitch,
        // and on a WBSC feed that never publishes them. The optional chain has
        // to reach the index too, or this throws on exactly those games.
        this.pitcher = this.game?.home?.pitchers?.[0];
      }
      this.teamBrg = this.utilService.getTeamBgrByGuid(this.broadcast.config.homeConfig.id, this.broadcast);
      this.teamSide = 'home';
    } else if (this.awayCtrl === 'on') {
      if (this.broadcast.config.useManualLineups && this.broadcast.manualLineups?.awayLineup) {
        // Convert manual lineup to LineupSpot[] format
        this.lineup = this.broadcast.manualLineups.awayLineup.map(player => {
          return { players: [player] };
        });
        this.pitcher = this.broadcast.manualLineups.awayPitcher || null;
      } else {
        this.lineup = this.game?.away?.lineup ?? [];
        this.pitcher = this.game?.away?.pitchers?.[0];
      }
      this.teamBrg = this.utilService.getTeamBgrByGuid(this.broadcast.config.awayConfig.id, this.broadcast);
      this.teamSide = 'away';
    } else {
      this.lineup = [];
      this.pitcher = null;
      // teamSide záměrně neměníme – drží posledně zobrazený tým kvůli plynulé animaci.
    }
  }

  getFontSize(player: Player): number {
    if (player?.name?.length > 40) {
      return 24;
    }
    if (player?.name?.length > 35) {
      return 26;
    }
    if (player?.name?.length > 30) {
      return 28;
    }
    if (player?.name?.length > 28) {
      return 30;
    }
    return 32;
  }
}
